const CUSTOMER_AUTH_TOKEN_KEY = 'customerAuthToken';

export const getStoredCustomerAuthToken = (): string | null => {
  try {
    const token = window.localStorage.getItem(CUSTOMER_AUTH_TOKEN_KEY);
    return token?.trim() || null;
  } catch {
    return null;
  }
};

export const saveCustomerAuthToken = (token: string | null | undefined): void => {
  try {
    if (!token || !token.trim()) {
      window.localStorage.removeItem(CUSTOMER_AUTH_TOKEN_KEY);
      return;
    }
    window.localStorage.setItem(CUSTOMER_AUTH_TOKEN_KEY, token.trim());
  } catch {
    // Ignore storage failures and continue.
  }
};

export const clearCustomerAuthToken = (): void => {
  try {
    window.localStorage.removeItem(CUSTOMER_AUTH_TOKEN_KEY);
  } catch {
    // Ignore storage failures and continue.
  }
};

export const getCustomerAuthHeaders = (): Record<string, string> => {
  const token = getStoredCustomerAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
